(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5477],{

/***/ 7208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ MainHome; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(7048);
// EXTERNAL MODULE: ./components/Footer/Footer.jsx + 2 modules
var Footer = __webpack_require__(8050);
// EXTERNAL MODULE: ./components/Infobanner/StaticInfoBanner.jsx
var StaticInfoBanner = __webpack_require__(7103);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(1439);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intersection-observer@8.34.0_react@18.3.1/node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(1003);
// EXTERNAL MODULE: ./node_modules/.pnpm/resize-observer-polyfill@1.5.1/node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(3023);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.44.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(3805);
// EXTERNAL MODULE: ./services/frontend/storefront-apis.js + 3 modules
var storefront_apis = __webpack_require__(5666);
;// CONCATENATED MODULE: ./hooks/useStorefrontCollection.js


/**
 * Resolve /collections/<handle> on the backend: the collection, plus `redirect` (its canonical
 * handle) when the URL is an old one. Not limited to the collections list, so any active
 * collection resolves. A 404 is final, so it is not retried.
 */

var useStorefrontCollection = function useStorefrontCollection(handle) {
  return (0,useQuery/* useQuery */.a)({
    queryKey: ["storefrontCollection", handle],
    queryFn: function queryFn() {
      return (0,storefront_apis/* getStorefrontCollection */.iH)(handle);
    },
    enabled: Boolean(handle) && handle !== "all",
    retry: function retry(failureCount, error) {
      return (error === null || error === void 0 ? void 0 : error.code) !== "COLLECTION_NOT_FOUND" && failureCount < 2;
    },
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000
  });
};

/* harmony default export */ var hooks_useStorefrontCollection = (useStorefrontCollection);
// EXTERNAL MODULE: ./hooks/useStorefrontCollections.js
var useStorefrontCollections = __webpack_require__(1126);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(4697);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(1260);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.44.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(6587);
;// CONCATENATED MODULE: ./lib/listingFilters.js


/**
 * Listing filters live in the URL (?minPrice=&maxPrice=&inStock=1&sort=price_asc) so a filtered
 * listing can be shared and the back button undoes a change. The backend matches a product when
 * ONE of its variants passes every filter, and lists it once.
 */
var LISTING_SORTS = [{
  value: "newest",
  label: "Newest"
}, {
  value: "price_asc",
  label: "Price: low to high"
}, {
  value: "price_desc",
  label: "Price: high to low"
}];
var SORT_VALUES = LISTING_SORTS.map(function (s) {
  return s.value;
});
var FILTER_KEYS = ["minPrice", "maxPrice", "inStock", "sort"];

var parsePrice = function parsePrice(raw) {
  if (typeof raw !== "string" || raw.trim() === "") return undefined;
  var n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? n : undefined;
};
/** Filters from Next's router.query; anything malformed is dropped rather than sent. */


var filtersFromQuery = function filtersFromQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var minPrice = parsePrice(query.minPrice);
  var maxPrice = parsePrice(query.maxPrice);

  if (minPrice !== undefined && maxPrice !== undefined && minPrice > maxPrice) {
    var _ref = [maxPrice, minPrice];
    minPrice = _ref[0];
    maxPrice = _ref[1];
  }

  return {
    minPrice: minPrice,
    maxPrice: maxPrice,
    inStock: query.inStock === "1" || query.inStock === "true",
    sort: SORT_VALUES.includes(query.sort) && query.sort !== "newest" ? query.sort : undefined
  };
};
/** Query params for the URL and the API: only filters that are set. */

var filtersToQuery = function filtersToQuery() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      minPrice = _ref2.minPrice,
      maxPrice = _ref2.maxPrice,
      inStock = _ref2.inStock,
      sort = _ref2.sort;

  var query = {};
  if (minPrice !== undefined) query.minPrice = String(minPrice);
  if (maxPrice !== undefined) query.maxPrice = String(maxPrice);
  if (inStock) query.inStock = "1";
  if (sort && sort !== "newest") query.sort = sort;
  return query;
};
/** How many filters are on (the badge on the Filter button). Sort counts as one. */

var activeFilterCount = function activeFilterCount(filters) {
  var query = filtersToQuery(filters);
  return (query.minPrice || query.maxPrice ? 1 : 0) + (query.inStock ? 1 : 0) + (query.sort ? 1 : 0);
};
/** router.query without the filter keys. */

var withoutFilters = function withoutFilters() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.fromEntries(Object.entries(query).filter(function (_ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 1),
        key = _ref4[0];

    return !FILTER_KEYS.includes(key);
  }));
};
;// CONCATENATED MODULE: ./hooks/useStorefrontProducts.js







var fetchStorefrontProducts = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var queryKey, _ref$pageParam, pageParam, _queryKey, collectionName, filters, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryKey = _ref.queryKey, _ref$pageParam = _ref.pageParam, pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
            _queryKey = (0,slicedToArray/* default */.Z)(queryKey, 3), collectionName = _queryKey[1], filters = _queryKey[2];
            _context.next = 4;
            return (0,storefront_apis/* getStorefrontProducts */.YK)({
              page: pageParam,
              limit: 20,
              collection: collectionName || "all",
              filters: filters
            });

          case 4:
            data = _context.sent;
            return _context.abrupt("return", {
              products: data.products || [],
              priceRange: data.priceRange || null,
              nextPage: pageParam + 1,
              previousPage: pageParam > 1 ? pageParam - 1 : null,
              hasNextPage: Boolean(data.hasNextPage)
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchStorefrontProducts(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/** `filters`: lib/listingFilters shape; part of the query key, so each filter set caches apart. */


var useStorefrontProducts = function useStorefrontProducts(collectionName, filters) {
  var enabled = Boolean(collectionName) && collectionName !== "__none__";
  return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
    queryKey: ["storefrontProducts", collectionName, filtersToQuery(filters)],
    queryFn: fetchStorefrontProducts,
    getNextPageParam: function getNextPageParam(lastPage) {
      return lastPage.hasNextPage ? lastPage.nextPage : undefined;
    },
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000,
    // Keep the old listing only while switching between real queries; while the route is still
    // resolving (no key yet) show the loading state, not the previous collection's products.
    keepPreviousData: enabled,
    enabled: enabled
  });
};

/* harmony default export */ var hooks_useStorefrontProducts = (useStorefrontProducts);
// EXTERNAL MODULE: ./lib/collectionUrls.js
var collectionUrls = __webpack_require__(3874);
// EXTERNAL MODULE: ./store/cart-store.js
var cart_store = __webpack_require__(2071);
// EXTERNAL MODULE: ./components/Cart/Basket.jsx + 1 modules
var Basket = __webpack_require__(2114);
// EXTERNAL MODULE: ./components/Navbar/index.jsx + 3 modules
var Navbar = __webpack_require__(6274);
// EXTERNAL MODULE: ./components/ShopStatusPage.jsx
var ShopStatusPage = __webpack_require__(5847);
// EXTERNAL MODULE: ./components/SideNavDrawer.jsx + 1 modules
var SideNavDrawer = __webpack_require__(5538);
// EXTERNAL MODULE: ./components/Skeleton.jsx
var Skeleton = __webpack_require__(2539);
// EXTERNAL MODULE: ./components/SkeletonCard.jsx
var SkeletonCard = __webpack_require__(5161);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/CollectionFilter.jsx




var CollectionFilter = function CollectionFilter(_ref) {
  var _selectedName$toLower;

  var collection = _ref.collection,
      selectedCollection = _ref.selectedCollection,
      setFilter = _ref.setFilter;
  var collectionTitle = typeof collection === "string" ? collection : collection === null || collection === void 0 ? void 0 : collection.title;
  var selectedName = typeof selectedCollection === "string" ? selectedCollection : selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection.title;
  var isAllSelected = !selectedCollection || selectedCollection._id === ALL_PRODUCTS_OBJECT._id || (selectedName === null || selectedName === void 0 ? void 0 : (_selectedName$toLower = selectedName.toLowerCase) === null || _selectedName$toLower === void 0 ? void 0 : _selectedName$toLower.call(selectedName)) === ALL_PRODUCTS_OBJECT.title; // By id: two collections can share a title up to case ("Shoes" / "shoes").

  var collectionId = typeof collection === "string" ? null : (collection === null || collection === void 0 ? void 0 : collection.id) || (collection === null || collection === void 0 ? void 0 : collection._id);
  var selectedId = typeof selectedCollection === "string" ? null : (selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection.id) || (selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection._id);
  var isSelected = !isAllSelected && (collectionId && selectedId ? collectionId === selectedId : Boolean(collectionTitle) && collectionTitle === selectedName);

  var handleClick = function handleClick() {
    if (isSelected) {
      setFilter(typeof collection === "string" ? undefined : ALL_PRODUCTS_OBJECT);
      return;
    }

    setFilter(collection);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    type: "button",
    className: "flex shrink-0 select-none items-center justify-center whitespace-nowrap rounded-full border px-[14px] py-2.5 text-[11px] font-medium leading-none text-mutedInk transition-colors ".concat(isSelected ? "border-mutedInk bg-transparent" : "border-gray-300 bg-transparent"),
    onClick: handleClick,
    children: collectionTitle
  });
};

/* harmony default export */ var components_CollectionFilter = (CollectionFilter);
;// CONCATENATED MODULE: ./components/StoreCollections.jsx




var StoreCollections = function StoreCollections(_ref) {
  var collections = _ref.collections,
      setFilter = _ref.setFilter,
      selectedCollection = _ref.selectedCollection;
  var collectionRefs = (0,react.useRef)({});
  var storeCollections = (0,react.useMemo)(function () {
    return collections.map(function (collection) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: function ref(el) {
          var id = typeof collection === "string" ? collection : collection._id || collection.id;
          collectionRefs.current[id] = el;
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_CollectionFilter, {
          collection: collection,
          selectedCollection: selectedCollection,
          setFilter: setFilter
        })
      }, collection._id || collection);
    });
  }, [collections, selectedCollection, setFilter]);
  (0,react.useEffect)(function () {
    if (selectedCollection && selectedCollection._id !== "all") {
      var targetRef = collectionRefs.current[selectedCollection._id || selectedCollection.id];

      if (targetRef) {
        setTimeout(function () {
          targetRef.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
          });
        }, 100);
      }
    }
  }, [selectedCollection]);
  return collections.length ? storeCollections : null;
};

/* harmony default export */ var components_StoreCollections = (StoreCollections);
// EXTERNAL MODULE: ./components/StoreItem.jsx + 2 modules
var StoreItem = __webpack_require__(2245);
// EXTERNAL MODULE: ./components/Home/RestorableList.jsx
var RestorableList = __webpack_require__(4973);
;// CONCATENATED MODULE: ./components/Home/CollectionHome.jsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











 // Listing filter hidden for now.
// import ListingFilter from "../ListingFilter";











var ALL_PRODUCTS_OBJECT = {
  title: "all products",
  _id: "all",
  id: "all"
};

var pathForCollection = function pathForCollection(collection) {
  if (!collection || collection._id === "all" || collection.title === "all products") {
    return "/collections/all";
  }

  return (0,collectionUrls/* collectionPath */.vd)(collection);
};

var CollectionHome = function CollectionHome(_ref) {
  var store = _ref.store,
      theme = _ref.theme,
      hasBanner = _ref.hasBanner;
  var router = (0,next_router.useRouter)(); // The URL segment: a collection handle, or "all". Next has already decoded it.

  var routeHandle = (0,react.useMemo)(function () {
    if (router.pathname === "/collections/all") return "all";

    if (router.pathname === "/collections/[name]") {
      if (typeof router.query.name !== "string") return null; // wait for router
      // "all" in any case is the all-products listing, as it was before handles.

      return router.query.name.toLowerCase() === "all" ? "all" : router.query.name;
    } // Homepage listing (and any non-collections host of this component) = all products


    return "all";
  }, [router.pathname, router.query.name]);
  var isAllRoute = routeHandle === "all";

  var _useState = (0,react.useState)(null),
      lastEl = _useState[0],
      setLastEl = _useState[1];

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var _useStorefrontCollect = (0,useStorefrontCollections/* default */.Z)(),
      collectionsData = _useStorefrontCollect.data,
      isCollectionsLoading = _useStorefrontCollect.isLoading,
      collectionsError = _useStorefrontCollect.error;

  var collections = (0,react.useMemo)(function () {
    return (collectionsData === null || collectionsData === void 0 ? void 0 : collectionsData.collections) || [];
  }, [collectionsData]); // A URL that is a listed collection's handle is already resolved (chip taps, nav links).

  var listedCollection = (0,react.useMemo)(function () {
    return routeHandle && !isAllRoute ? (0,collectionUrls/* findCollectionByHandle */.Dz)(collections, routeHandle) : null;
  }, [routeHandle, isAllRoute, collections]); // Anything else (beyond the capped list, or an old URL) is resolved by the backend, which
  // answers old URLs with a redirect. Asked only once the list has loaded without a match.

  var needsLookup = Boolean(routeHandle) && !isAllRoute && !isCollectionsLoading && !listedCollection;
  var lookup = hooks_useStorefrontCollection(needsLookup ? routeHandle : null);
  var collectionLookup = needsLookup ? lookup.data : null;
  var collectionLookupError = needsLookup ? lookup.error : null; // Null until the route resolves: nothing is fetched, so a deep link never flashes the
  // all-products listing (or the previous collection's products) first.

  var selectedCollection = (0,react.useMemo)(function () {
    if (routeHandle === null) return null;
    if (isAllRoute) return ALL_PRODUCTS_OBJECT;
    if (listedCollection) return listedCollection;
    var resolved = collectionLookup === null || collectionLookup === void 0 ? void 0 : collectionLookup.collection;
    return resolved ? _objectSpread(_objectSpread({}, resolved), {}, {
      _id: resolved.id
    }) : null;
  }, [routeHandle, isAllRoute, listedCollection, collectionLookup]); // Old URL (edited handle, or the pre-handle "%20" name URL): move to the canonical one.

  var redirectHandle = collectionLookup === null || collectionLookup === void 0 ? void 0 : collectionLookup.redirect;
  (0,react.useEffect)(function () {
    if (!redirectHandle || redirectHandle === routeHandle) return;
    router.replace({
      pathname: (0,collectionUrls/* collectionPath */.vd)({
        handle: redirectHandle
      }),
      query: filtersToQuery(filtersFromQuery(router.query))
    }, undefined, {
      scroll: false
    });
  }, [redirectHandle, routeHandle, router]);
  var productFilterKey = selectedCollection ? selectedCollection._id === "all" ? "all" : selectedCollection.handle || selectedCollection.title : undefined; // Price / stock / sort filters come from the URL and carry over when the collection changes.

  var _router$query = router.query,
      qMin = _router$query.minPrice,
      qMax = _router$query.maxPrice,
      qStock = _router$query.inStock,
      qSort = _router$query.sort;
  var filters = (0,react.useMemo)(function () {
    return filtersFromQuery({
      minPrice: qMin,
      maxPrice: qMax,
      inStock: qStock,
      sort: qSort
    });
  }, [qMin, qMax, qStock, qSort]);
  var filtersOn = activeFilterCount(filters) > 0;
  var applyFilters = (0,react.useCallback)(function (next) {
    router.push({
      pathname: router.pathname,
      query: _objectSpread(_objectSpread({}, withoutFilters(router.query)), filtersToQuery(next))
    }, undefined, {
      scroll: false
    });
  }, [router]);

  var _useStorefrontProduct = hooks_useStorefrontProducts(productFilterKey, filters),
      productData = _useStorefrontProduct.data,
      isProductsLoading = _useStorefrontProduct.isLoading,
      isFetchingNextPage = _useStorefrontProduct.isFetchingNextPage,
      fetchNextPage = _useStorefrontProduct.fetchNextPage,
      hasNextPage = _useStorefrontProduct.hasNextPage,
      productError = _useStorefrontProduct.error;

  var collectionMissing = (collectionLookupError === null || collectionLookupError === void 0 ? void 0 : collectionLookupError.code) === "COLLECTION_NOT_FOUND" || (productError === null || productError === void 0 ? void 0 : productError.code) === "COLLECTION_NOT_FOUND";
  var products = (productData === null || productData === void 0 ? void 0 : productData.pages.flatMap(function (page) {
    return page.products;
  })) || []; // Only the hidden listing filter reads this.
  // const priceRange = productData?.pages[0]?.priceRange || null;

  var hasHydrated = (0,cart_store/* default */.Z)(function (s) {
    return s.hasHydrated;
  });
  var setCart = (0,cart_store/* default */.Z)(function (s) {
    return s.setCart;
  });
  var cartProducts = (0,cart_store/* default */.Z)(function (s) {
    return s.products;
  });
  var cart = {
    products: cartProducts
  };

  var _useState2 = (0,react.useState)(false),
      showCart = _useState2[0],
      setShowCart = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showSideNav = _useState3[0],
      setShowSideNav = _useState3[1];

  var handleShowCart = (0,react.useCallback)(function () {
    var boolVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (isCollectionsLoading || collectionsError || productError) return;
    setShowCart(boolVal);
  }, [isCollectionsLoading, collectionsError, productError]); // The selection follows the URL; the query key changes with it, so no invalidate — that was
  // refetching the old collection AND the new one on every tap/untap.

  var setFilter = (0,react.useCallback)(function (collection) {
    router.push({
      pathname: pathForCollection(collection || ALL_PRODUCTS_OBJECT),
      query: filtersToQuery(filters)
    });
  }, [router, filters]);
  (0,react.useEffect)(function () {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);
  (0,react.useEffect)(function () {
    if (!products.length) return;

    var _products$slice = products.slice(-1),
        _products$slice2 = (0,slicedToArray/* default */.Z)(_products$slice, 1),
        lastElement = _products$slice2[0];

    setLastEl(lastElement.id);
  }, [products]);

  var updateAddedToCart = function updateAddedToCart() {};

  if (collectionMissing) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ShopStatusPage/* default */.Z, {
      embedded: true,
      message: "The page you are looking for does not exist."
    });
  }

  if (collectionsError || productError || collectionLookupError) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "mt-8 px-5 ".concat(ShopStatusPage/* statusCopyClassName */.m),
      children: "Something went wrong."
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "scrollbar-none min-h-[calc(100vh-268px)] w-full font-montserrat",
    children: [hasHydrated && /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
      isBasketOpen: showCart,
      setCart: setCart,
      cartData: cart,
      updateAddedToCart: updateAddedToCart,
      handleShowCart: handleShowCart,
      store: store,
      setRefresh: function setRefresh() {}
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default */.Z, {
      cartActive: cart.products.length > 0,
      handleShowCart: handleShowCart,
      hideInAdvance: false,
      homeActive: Boolean(hasBanner),
      store: store,
      theme: theme,
      storeName: (store === null || store === void 0 ? void 0 : store.name) || "",
      toggleSideNav: function toggleSideNav() {
        return setShowSideNav(!showSideNav);
      },
      sideNavOpen: showSideNav,
      homePage: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
      isOpen: showSideNav,
      toggleDrawer: function toggleDrawer() {
        return setShowSideNav(!showSideNav);
      },
      handleShowCart: handleShowCart,
      store: store
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "px-[22px]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative z-10 mt-2 flex max-w-[500px] items-center justify-end gap-[10px]",
        children: isCollectionsLoading || collections.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "hide-scrollbar flex min-w-0 flex-1 items-center gap-[10px] overflow-x-auto overflow-y-hidden scroll-smooth px-0 py-1",
          children: [collections.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_StoreCollections, {
            collections: collections,
            setFilter: setFilter,
            selectedCollection: selectedCollection
          }) : null, isCollectionsLoading && Array(3).fill(0).map(function (_, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
              className: "h-[42px] w-[100px] shrink-0 rounded-2xl border border-gray-200"
            }, i);
          })]
        }) : null
      }), products.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative mt-4 min-h-[80vh]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RestorableList/* default */.Z, {
          children: Array.from({
            length: Math.ceil(products.length / 2)
          }, function (_, rowIndex) {
            var startIndex = rowIndex * 2;
            var rowProducts = products.slice(startIndex, startIndex + 2);
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "grid grid-cols-2 gap-4 pb-4",
              children: rowProducts.map(function (product) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "min-w-0",
                  ref: lastEl === product.id ? ref : null,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
                    product: product,
                    top: rowIndex === 0
                  })
                }, product.id);
              })
            }, rowProducts[0].id);
          })
        })
      }) : !isProductsLoading && !collectionMissing && (filtersOn ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mt-6 flex flex-col items-start gap-3",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-base font-normal text-checkoutText",
          children: "No products match these filters."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          onClick: function onClick() {
            return applyFilters({});
          },
          className: "text-sm font-medium text-checkoutText underline",
          children: "Clear filters"
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mt-6 text-base font-normal text-checkoutText",
        children: "No products found."
      })), (isFetchingNextPage || isProductsLoading) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-4 grid grid-cols-2 gap-4",
        children: Array(6).fill(0).map(function (_, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonCard/* default */.Z, {
              imageClass: "aspect-square h-auto w-full rounded-lg",
              titleClass: "h-4 w-full",
              descriptionClass: "h-4 w-2/3",
              containerClass: "w-full"
            }, i)
          }, i);
        })
      })]
    })]
  });
};

/* harmony default export */ var Home_CollectionHome = (CollectionHome);
;// CONCATENATED MODULE: ./hooks/useStorefrontHome.js






var fetchStorefrontHome = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var _data$page, _data$limit;

    var queryKey, _ref$pageParam, pageParam, _queryKey, limit, productLimit, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryKey = _ref.queryKey, _ref$pageParam = _ref.pageParam, pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
            _queryKey = (0,slicedToArray/* default */.Z)(queryKey, 3), limit = _queryKey[1], productLimit = _queryKey[2];
            _context.next = 4;
            return (0,storefront_apis/* getStorefrontHome */.OO)({
              page: pageParam,
              limit: limit,
              productLimit: productLimit
            });

          case 4:
            data = _context.sent;
            return _context.abrupt("return", {
              collections: data.collections || [],
              reviews: data.reviews,
              page: (_data$page = data.page) !== null && _data$page !== void 0 ? _data$page : pageParam,
              limit: (_data$limit = data.limit) !== null && _data$limit !== void 0 ? _data$limit : limit,
              nextPage: pageParam + 1,
              hasNextPage: Boolean(data.hasNextPage)
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchStorefrontHome(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useStorefrontHome = function useStorefrontHome() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var productLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
    queryKey: ["storefrontHome", limit, productLimit],
    queryFn: fetchStorefrontHome,
    getNextPageParam: function getNextPageParam(lastPage) {
      return lastPage.hasNextPage ? lastPage.nextPage : undefined;
    },
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000
  });
};

/* harmony default export */ var hooks_useStorefrontHome = (useStorefrontHome);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazy-load-image-component@1.6.3_react@18.3.1/node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(2027);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazy-load-image-component@1.6.3_react@18.3.1/node_modules/react-lazy-load-image-component/src/effects/blur.css
var effects_blur = __webpack_require__(1314);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1485);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(8122);
;// CONCATENATED MODULE: ./components/Reviews/Reviews.jsx







var Reviews = function Reviews(_ref) {
  var _ref$reviews = _ref.reviews,
      reviews = _ref$reviews === void 0 ? [] : _ref$reviews,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  if (!isLoading && (!reviews || reviews.length === 0)) return null;
  var renderSkeletons = Array(6).fill(0).map(function (_, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewSkeleton, {}, i);
  });
  var renderReviews = (reviews || []).map(function (review) {
    var photo = review.photo;
    var photoSrc = typeof photo === "string" ? photo : photo === null || photo === void 0 ? void 0 : photo.src;
    var photoV2 = typeof photo === "object" ? photo : null;
    var resolved = (0,media/* resolveImage */.rs)(photoSrc, photoV2, "review");
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-[342px] w-[256px] shrink-0 overflow-hidden rounded-lg border border-gray-200",
      children: resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
        resolved: resolved,
        alt: review.title || "Review Image",
        className: "h-full w-full",
        imgClassName: "h-full w-full object-cover"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(build.LazyLoadImage, {
        className: "h-full w-full object-cover",
        height: "100%",
        width: "100%",
        src: resolved.src,
        alt: review.title || "Review Image",
        effect: "blur"
      })
    }, review.id);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-8 px-5",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "text-[20px] font-normal capitalize tracking-[0.5px] text-checkoutText",
      children: "Customer Reviews"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hide-scrollbar mt-4 flex gap-x-4 overflow-x-auto",
      children: isLoading ? renderSkeletons : renderReviews
    })]
  });
};

var ReviewSkeleton = function ReviewSkeleton() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "h-[342px] w-[256px] shrink-0 animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-gray-200"
  });
};

/* harmony default export */ var Reviews_Reviews = (Reviews);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(153);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Home/FeaturedCollectionWithProd.jsx




/**
 * Component to display a collection with its products in a horizontal scrollable list
 *
 * @param {Object} props - Component props
 * @param {string} props.collectionTitle - Title of the collection
 * @param {string} [props.collectionHandle] - URL handle of the collection
 * @param {Array} props.productsData - Array of products in the collection
 */




var FeaturedCollectionWithProd = function FeaturedCollectionWithProd(_ref) {
  var collectionTitle = _ref.collectionTitle,
      collectionHandle = _ref.collectionHandle,
      productsData = _ref.productsData;
  var products = productsData || [];

  if (products.length === 0) {
    return null;
  }

  var formattedCollectionName = (collectionTitle === null || collectionTitle === void 0 ? void 0 : collectionTitle.toLowerCase()) || "";
  var collectionUrl = (0,collectionUrls/* collectionPath */.vd)({
    handle: collectionHandle,
    title: collectionTitle
  }); // V1 homepage is always a 2-column grid. theme.collectionScrollDirection is ignored here.

  var isVerticalScroll = true;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "px-5",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
      className: "mt-8 text-lg font-normal capitalize tracking-[0.5px] text-checkoutText",
      children: ["Shop ", formattedCollectionName]
    }), isVerticalScroll ?
    /*#__PURE__*/
    // Vertical grid layout
    (0,jsx_runtime.jsx)("div", {
      className: "mt-4 grid grid-cols-2 gap-4",
      children: products.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
          product: product,
          pageSize: products.length
        }, product.id);
      })
    }) :
    /*#__PURE__*/
    // Horizontal scroll layout
    (0,jsx_runtime.jsx)("div", {
      className: "hide-scrollbar flex flex-row gap-4 overflow-x-auto overflow-y-hidden whitespace-nowrap",
      children: products.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
          usedForCollectionhome: true,
          product: product,
          pageSize: products.length
        }, product.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: collectionUrl,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        className: "mx-auto mt-4 block w-fit rounded-full border border-mutedInk px-3.5 py-2.5 text-center text-[11px] font-medium capitalize text-mutedInk",
        children: ["Shop ", formattedCollectionName]
      })
    })]
  });
};

/* harmony default export */ var Home_FeaturedCollectionWithProd = (FeaturedCollectionWithProd);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-responsive-carousel@3.2.23/node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(6050);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-responsive-carousel@3.2.23/node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(4893);
// EXTERNAL MODULE: ./lib/cdn.js
var cdn = __webpack_require__(351);
// EXTERNAL MODULE: ./components/Home/home-hero.module.css
var home_hero_module = __webpack_require__(6280);
var home_hero_module_default = /*#__PURE__*/__webpack_require__.n(home_hero_module);
;// CONCATENATED MODULE: ./components/Home/HomeHero.jsx









var getHeroPhotoSrc = function getHeroPhotoSrc(photo) {
  if (!photo) return "";
  return (0,cdn/* toCdnUrl */.V$)(photo);
};

var HomeHero = function HomeHero(_ref) {
  var rawPhotos = _ref.photos,
      onShop = _ref.onShop;
  var photos = Array.isArray(rawPhotos) ? rawPhotos.filter(Boolean) : [];
  if (photos.length === 0) return null;
  var hasMultiplePhotos = photos.length > 1;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "z-10 w-full px-5",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((home_hero_module_default()).gallery, " relative mx-auto mt-4 h-[400px] max-h-[400px] max-w-full overflow-hidden rounded-2xl sm:mx-0 sm:h-[500px] sm:max-h-[500px] sm:w-full"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(js/* Carousel */.lr, {
        className: "h-full",
        autoPlay: hasMultiplePhotos,
        interval: 1500,
        infiniteLoop: hasMultiplePhotos,
        stopOnHover: false,
        showThumbs: false,
        showStatus: false,
        showArrows: false,
        showIndicators: false,
        animationHandler: "fade",
        swipeable: false,
        onClickItem: onShop,
        children: photos.map(function (photo, index) {
          var src = typeof photo === "string" ? photo : photo === null || photo === void 0 ? void 0 : photo.src;
          if (!src) return null;
          var resolved = (0,media/* resolveImage */.rs)(src, typeof photo === "object" ? photo : null, "hero");

          if (resolved.isV2) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full w-full overflow-hidden",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
                resolved: resolved,
                alt: "",
                loading: index === 0 ? "eager" : "lazy",
                fetchpriority: index === 0 ? "high" : undefined,
                className: "h-full w-full",
                imgClassName: "h-full w-full cursor-pointer object-cover object-center"
              })
            }, "".concat(photo, "-").concat(index));
          }

          var legacySrc = getHeroPhotoSrc(src);
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "h-full w-full overflow-hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: legacySrc,
              alt: "",
              fetchpriority: index === 0 ? "high" : "auto",
              onError: function onError(e) {
                if (e.currentTarget.src !== src) {
                  e.currentTarget.src = src;
                }
              },
              className: "h-full w-full cursor-pointer object-cover object-center"
            })
          }, "".concat(src, "-").concat(index));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: onShop,
        className: "absolute bottom-4 left-1/2 z-30 -translate-x-1/2 rounded-full bg-[var(--theme-action-fill)] px-4 py-2 text-xs text-[var(--theme-action-text)]",
        children: "Shop All"
      })]
    })
  });
};

/* harmony default export */ var Home_HomeHero = (HomeHero);
;// CONCATENATED MODULE: ./components/Home/FeaturedHome.jsx

















var FeaturedHome = function FeaturedHome(_ref) {
  var _homeData$pages, _homeData$pages2, _homeData$pages2$;

  var theme = _ref.theme,
      store = _ref.store,
      updateHomeActive = _ref.updateHomeActive,
      heroPhotos = _ref.heroPhotos;
  var hasHydrated = (0,cart_store/* default */.Z)(function (s) {
    return s.hasHydrated;
  });
  var setCart = (0,cart_store/* default */.Z)(function (s) {
    return s.setCart;
  });
  var products = (0,cart_store/* default */.Z)(function (s) {
    return s.products;
  });
  var cart = {
    products: products
  };

  var _useState = (0,react.useState)(false),
      showCart = _useState[0],
      setShowCart = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showSideNav = _useState2[0],
      setShowSideNav = _useState2[1];

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0.1,
    triggerOnce: false
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var updateAddedToCart = function updateAddedToCart() {};

  var handleShowCart = function handleShowCart() {
    var boolVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setShowCart(boolVal);
  };

  var _useStorefrontHome = hooks_useStorefrontHome(5, 4),
      homeData = _useStorefrontHome.data,
      isHomeInitialLoading = _useStorefrontHome.isLoading,
      isFetchingNextPage = _useStorefrontHome.isFetchingNextPage,
      fetchNextPage = _useStorefrontHome.fetchNextPage,
      hasNextPage = _useStorefrontHome.hasNextPage;

  var collectionsWithProducts = (homeData === null || homeData === void 0 ? void 0 : (_homeData$pages = homeData.pages) === null || _homeData$pages === void 0 ? void 0 : _homeData$pages.flatMap(function (page) {
    return page.collections || [];
  })) || [];
  var reviews = (homeData === null || homeData === void 0 ? void 0 : (_homeData$pages2 = homeData.pages) === null || _homeData$pages2 === void 0 ? void 0 : (_homeData$pages2$ = _homeData$pages2[0]) === null || _homeData$pages2$ === void 0 ? void 0 : _homeData$pages2$.reviews) || [];
  (0,react.useEffect)(function () {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage, isFetchingNextPage]);

  var renderLoadingSkeletons = function renderLoadingSkeletons(key) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "m-5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
        className: "mx-auto mb-[30px] mt-[50px] h-8 w-28 text-center font-bold text-primary"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hide-scrollbar flex flex-row gap-4 overflow-x-auto overflow-y-hidden whitespace-nowrap",
        children: Array(2).fill(0).map(function (_, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonCard/* default */.Z, {
            className: "m-[4px_5px_5px_4px] w-[10px] rounded-[50px] px-5 py-[4px]",
            imageClass: "w-[calc((var(--max-width)/1.5)-50px)] h-[calc((var(--max-width)/1.5)-50px)]"
          }, i);
        })
      })]
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "font-montserrat",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StaticInfoBanner/* default */.Z, {
      text: store === null || store === void 0 ? void 0 : store.announcement
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "sticky top-0 z-50 flex h-full w-full justify-center",
      children: [hasHydrated && /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
        isBasketOpen: showCart,
        setCart: setCart,
        cartData: cart,
        updateAddedToCart: updateAddedToCart,
        handleShowCart: handleShowCart,
        store: store,
        setRefresh: function setRefresh() {}
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default */.Z, {
        cartActive: hasHydrated && cart.products.length > 0,
        hideInAdvance: false,
        homeActive: true,
        storeName: (store === null || store === void 0 ? void 0 : store.name) || "",
        handleShowCart: handleShowCart,
        store: store,
        theme: theme,
        toggleSideNav: function toggleSideNav() {
          return setShowSideNav(!showSideNav);
        },
        sideNavOpen: showSideNav,
        homePage: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
        isOpen: showSideNav,
        toggleDrawer: function toggleDrawer() {
          return setShowSideNav(!showSideNav);
        },
        handleShowCart: handleShowCart,
        store: store
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Home_HomeHero, {
      photos: heroPhotos,
      onShop: function onShop() {
        return updateHomeActive(false);
      }
    }), (isHomeInitialLoading || collectionsWithProducts.length > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full",
      children: isHomeInitialLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: Array(2).fill(0).map(function (_, index) {
          return renderLoadingSkeletons("initial-skeleton-".concat(index));
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [collectionsWithProducts.map(function (collection) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedCollectionWithProd, {
            collectionTitle: collection.title || "",
            collectionHandle: collection.handle,
            productsData: collection.products || []
          }, collection.id);
        }), isFetchingNextPage && renderLoadingSkeletons("loading-more-skeleton"), hasNextPage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: ref,
          className: "h-12 w-full",
          "aria-hidden": "true"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Reviews_Reviews, {
      reviews: reviews,
      isLoading: isHomeInitialLoading
    })]
  });
};

/* harmony default export */ var Home_FeaturedHome = (FeaturedHome);
;// CONCATENATED MODULE: ./components/Home/ScrollPositionProvider.jsx

 // Create the context


var ScrollContext = /*#__PURE__*/(0,react.createContext)(); // Create a provider component

var ScrollProvider = function ScrollProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(0),
      scrollPosition = _useState[0],
      setScrollPosition = _useState[1];

  var updateScrollPosition = (0,react.useCallback)(function (position) {
    setScrollPosition(position);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollContext.Provider, {
    value: {
      scrollPosition: scrollPosition,
      updateScrollPosition: updateScrollPosition
    },
    children: children
  });
}; // Custom hook to use the ScrollContext

var useScroll = function useScroll() {
  var _useState2 = useState(0),
      scrollPosition = _useState2[0],
      setScrollPosition = _useState2[1];

  useEffect(function () {
    var savedPosition = localStorage.getItem("scrollPosition");

    if (savedPosition) {
      setScrollPosition(parseInt(savedPosition, 10));
    }
  }, []);

  var updateScrollPosition = function updateScrollPosition(position) {
    localStorage.setItem("scrollPosition", position);
    setScrollPosition(position);
  };

  return {
    scrollPosition: scrollPosition,
    updateScrollPosition: updateScrollPosition
  };
};
;// CONCATENATED MODULE: ./components/Home/MainHome.jsx








var MainHome = function MainHome(_ref) {
  var _store$announcement;

  var store = _ref.store,
      theme = _ref.theme,
      hideHeroMedia = _ref.hideHeroMedia;
  var router = (0,next_router.useRouter)();
  var homeActive = (store === null || store === void 0 ? void 0 : store.homeLayout) === "featured" && !hideHeroMedia;
  var hasBanner = Boolean(store === null || store === void 0 ? void 0 : (_store$announcement = store.announcement) === null || _store$announcement === void 0 ? void 0 : _store$announcement.trim());

  var updateHomeActive = function updateHomeActive() {
    router.push("/collections/all");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
    className: "flex min-h-screen w-screen max-w-app flex-col bg-background transition-[max-height] duration-200",
    children: [homeActive ? /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedHome, {
      theme: theme,
      store: store,
      updateHomeActive: updateHomeActive,
      heroPhotos: store === null || store === void 0 ? void 0 : store.heroPhotos
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ScrollProvider, {
      children: [hasBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(StaticInfoBanner/* default */.Z, {
        text: store === null || store === void 0 ? void 0 : store.announcement
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Home_CollectionHome, {
        store: store,
        theme: theme,
        hasBanner: hasBanner
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-auto",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})
    })]
  });
};

/***/ }),

/***/ 8953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StorefrontHead; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/head.js
var head = __webpack_require__(7094);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(7048);
// EXTERNAL MODULE: ./lib/media.js
var lib_media = __webpack_require__(1485);
;// CONCATENATED MODULE: ./lib/storefrontMeta.js

var DESC_FALLBACK = "Powered by Sh0p";
/** Host only: domain or `{username}.sh0p.in`. */

function storeHost(store) {
  if (!store) return "";

  if (store.domain) {
    return String(store.domain).replace(/^https?:\/\//, "").replace(/\/$/, "");
  }

  if (store.username) return "".concat(store.username, ".sh0p.in");
  return "";
}
function storeBaseUrl(store) {
  var host = storeHost(store);
  return host ? "https://".concat(host) : "";
}
/** Store base + path (no query/hash). Home → `https://host` (no trailing slash). */

function storePageUrl(store) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
  var base = storeBaseUrl(store);
  if (!base) return "";
  var raw = typeof path === "string" && path ? path : "/";
  var pathOnly = raw.split("?")[0].split("#")[0];
  var normalized = pathOnly.startsWith("/") ? pathOnly : "/".concat(pathOnly);
  if (normalized === "/") return base;
  return "".concat(base).concat(normalized);
}
function storeMetaTitle(store) {
  if (store !== null && store !== void 0 && store.name) return store.name;
  return storeHost(store);
}
function storeMetaDescription(store) {
  if (store !== null && store !== void 0 && store.about) return store.about;
  return DESC_FALLBACK;
}
function storeLogoUrl(store) {
  if (!(store !== null && store !== void 0 && store.logo)) return null;
  var src = typeof store.logo === "string" ? store.logo : store.logo.src;
  var media = typeof store.logo === "object" ? store.logo : null;
  var url = (0,lib_media/* ogImage */.Qf)(src, media);
  return url || null;
}
function buildStorefrontMeta(store) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
  var title = storeMetaTitle(store);
  var description = storeMetaDescription(store);
  var pageUrl = storePageUrl(store, path);
  var image = storeLogoUrl(store);
  return {
    title: title,
    description: description,
    pageUrl: pageUrl,
    image: image
  };
}
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/StorefrontHead.jsx



/**
 * Buyer storefront meta / og / twitter / favicon per DM2-247 lock.
 * Optional `path` overrides router.asPath (e.g. tests). Optional `robots` for noindex pages.
 */



function StorefrontHead(_ref) {
  var _ref2;

  var store = _ref.store,
      path = _ref.path,
      robots = _ref.robots;
  var router = (0,next_router.useRouter)();
  var pagePath = (_ref2 = path !== null && path !== void 0 ? path : router.asPath) !== null && _ref2 !== void 0 ? _ref2 : "/";

  var _buildStorefrontMeta = buildStorefrontMeta(store, pagePath),
      title = _buildStorefrontMeta.title,
      description = _buildStorefrontMeta.description,
      pageUrl = _buildStorefrontMeta.pageUrl,
      image = _buildStorefrontMeta.image;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [robots ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "robots",
      content: robots
    }) : null, title ? /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    }) : null, title ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "title",
      content: title
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: description
    }), image ? /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: image
    }) : null, pageUrl ? /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "canonical",
      href: pageUrl
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), title ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:title",
      content: title
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:description",
      content: description
    }), image ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image",
      content: image
    }) : null, title ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:site_name",
      content: title
    }) : null, pageUrl ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:url",
      content: pageUrl
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:card",
      content: "summary"
    }), pageUrl ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:url",
      content: pageUrl
    }) : null, title ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:title",
      content: title
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "twitter:description",
      content: description
    }), image ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "twitter:image",
      content: image
    }) : null]
  });
}

/***/ }),

/***/ 5803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_ShopStatusPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5847);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);



var Error500Page = function Error500Page() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ShopStatusPage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    message: "Something went wrong."
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Error500Page);

/***/ }),

/***/ 6280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery":"home-hero_gallery__1JAG5"};

/***/ })

}]);